// extracted by mini-css-extract-plugin
export default {"icon":"trashButton_icon__SmKIW"};